{
  "en": {
    "answers": [
      {
        "id": 1328683,
        "text": "Yes",
        "is_right": true
      },
      {
        "id": 1328684,
        "text": "No",
        "is_right": false
      }
    ],
    "tags": [
      {
        "id": 144338,
        "name": "Rating"
      },
      {
        "id": 156068,
        "name": "Sample Question"
      },
      {
        "id": 156083,
        "name": "Survey Question"
      }
    ],
    "text": "Are you satisfied with the course?",
    "display_in_order": true,
    "is_poll_question": true,
    "type": 2,
    "created_at": "2025-09-02T16:21:23.000Z",
    "created_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "updated_at": "2025-09-03T08:55:52.000Z",
    "updated_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "explanation": "* Please choose between **“Yes”** (positive rating) and **“No”** (negative rating).\n* This format is particularly useful for collecting quick and clear feedback.",
    "has_explanation": true,
    "num_answers": 2
  },
  "de": {
    "answers": [
      {
        "id": 1329041,
        "text": "Ja",
        "is_right": true
      },
      {
        "id": 1329042,
        "text": "Nein",
        "is_right": false
      }
    ],
    "tags": [
      {
        "id": 9427,
        "name": "Musterfrage"
      },
      {
        "id": 14279,
        "name": "Umfragen/Evaluationen"
      }
    ],
    "text": "Bist Du mit dem Kurs zufrieden?",
    "display_in_order": true,
    "is_poll_question": true,
    "type": 2,
    "created_at": "2025-09-03T08:00:33.000Z",
    "created_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "updated_at": "2025-09-03T08:26:37.000Z",
    "updated_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "explanation": "* Bitte wähle zwischen **„Ja“** (positive Bewertung) und **„Nein“** (negative Bewertung). \n* Diese Form eignet sich besonders für eine schnelle und eindeutige Rückmeldung.",
    "has_explanation": true,
    "num_answers": 2
  }
}
